<button
  data-test="jDgLmWMv"
  [class]="getButtonClasses()"
  tabindex="0"
  [disabled]="disabledButton || store.buttonsStatuses[id] === saveButtonStatus.SAVING"
  [type]="buttonType"
  (click)="save.emit()"
  *mdAutorun
><span data-test="-FiA1Ndv">{{ getButtonText(isDirty, isNew, store.buttonsStatuses[id]) }}</span></button>
